import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { childrenShape } from '@bibliocommons/bc-prop-types';

import './Heading.scss';

export default function Heading({
  className,
  children,
  size = 'modest',
  variant = false,
  linked = true,
  tagName: Tag,
  ...extraProps
}) {
  const classNames = cn('cp-heading', `heading-${size}`, className, {
    'heading--variant': variant,
    'heading--linked': linked
  });

  return (
    <Tag {...extraProps} className={classNames}>
      {children}
    </Tag>
  );
}

Heading.propTypes = {
  className: PropTypes.string,
  children: childrenShape.isRequired,
  tagName: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
  size: PropTypes.oneOf(['giant', 'large', 'moderate', 'medium', 'modest', 'small']),
  variant: PropTypes.bool,
  linked: PropTypes.bool
};
